module.exports = __webpack_public_path__ + "static/offices-content-image-tower@2x-df52f178449a5d8d3e22afed7a757d77.jpg";